module.exports = __webpack_public_path__ + "static/media/arts.abef93d9.jpg";